import colors from './colors'
import { fonts, fontSizes, textStyles } from './typography'
import sizes from './sizes'
import shadows from './shadows'
import semanticTokens from './semantic-tokens'

export const foundations = {
  colors,
  fonts,
  fontSizes,
  textStyles,
  sizes,
  shadows,
  semanticTokens,
}
